import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { carregarDadosPortal, escolherConteudo, trocarVideoTiktok } from '../lib/portal';
import PortalCasos from './portal/PortalCasos';
import PortalFinanceiro from './portal/PortalFinanceiro';
import PortalAcessos from './portal/PortalAcessos';
import PortalConteudo from './portal/PortalConteudo';
import PortalRelatorios from './portal/PortalRelatorios';
import '../styles/portal.css';

const ABAS = [
  { key: 'casos',      label: 'Casos' },
  { key: 'financeiro', label: 'Financeiro' },
  { key: 'conteudo',   label: 'Conteúdo' },
  { key: 'relatorios', label: 'Relatórios' },
  { key: 'acessos',    label: 'Acessos' },
];

export default function ClientPortal() {
  const { token } = useParams();
  const [dados, setDados] = useState(null);
  const [erro, setErro] = useState('');
  const [carregando, setCarregando] = useState(true);
  const [aba, setAba] = useState('casos');

  useEffect(() => {
    carregarDadosPortal(token)
      .then(setDados)
      .catch(e => setErro(e.message || 'Não foi possível carregar este portal.'))
      .finally(() => setCarregando(false));
  }, [token]);

  if (carregando) {
    return <div className="portal-page"><div className="portal-estado">Carregando...</div></div>;
  }

  if (erro || !dados) {
    return (
      <div className="portal-page">
        <div className="portal-estado">
          <div style={{ fontSize: 32, marginBottom: 10 }}>🔒</div>
          Este link não é válido. Confirme com a Vuli Group se o endereço está certo.
        </div>
      </div>
    );
  }

  return (
    <div className="portal-page">
      <div className="portal-header">
        <div className="logo-mark"><span className="logo-v">V</span></div>
        <div className="portal-header-texto">
          <strong>{dados.projeto.nome}</strong>
          <small>Área do Cliente · Vuli Group</small>
        </div>
      </div>

      <div className="portal-body">
        <div className="portal-tabs tabs-wrap">
          {ABAS.map(a => (
            <button key={a.key} onClick={() => setAba(a.key)} className={`tab-btn${aba === a.key ? ' active' : ''}`}>{a.label}</button>
          ))}
        </div>

        {aba === 'casos' && <PortalCasos casos={dados.casos} cobrancas={dados.cobrancas} corProjeto={dados.projeto.cor} />}
        {aba === 'financeiro' && <PortalFinanceiro cobrancas={dados.cobrancas} />}
        {aba === 'conteudo' && (
          <PortalConteudo
            conteudos={dados.conteudos}
            lotes={dados.lotes}
            token={token}
            persona={dados.persona}
            linkDriveCliente={dados.projeto.link_drive_cliente}
            onEventoAlterado={(conteudoId, etapa, marcado, detalhe) => {
              setDados(d => ({
                ...d,
                conteudos: d.conteudos.map(c => {
                  if (c.id !== conteudoId) return c;
                  const eventos = (c.eventos || []).filter(e => e.etapa !== etapa);
                  if (marcado) eventos.push({ etapa, criado_em: new Date().toISOString(), detalhe });
                  return { ...c, eventos };
                }),
              }));
            }}
            onEscolher={async (conteudoId, escolher) => {
              await escolherConteudo(token, conteudoId, escolher);
              setDados(d => ({
                ...d,
                conteudos: d.conteudos.map(c => c.id === conteudoId ? { ...c, escolhido_em: escolher ? new Date().toISOString() : null } : c),
              }));
            }}
            onTrocarTiktok={async (atualId, novoId) => {
              const atual = dados.conteudos.find(c => c.id === atualId);
              await trocarVideoTiktok(token, atualId, novoId);
              setDados(d => ({
                ...d,
                conteudos: d.conteudos.map(c => {
                  if (c.id === atualId) return { ...c, data: null };
                  if (c.id === novoId) return { ...c, data: atual.data };
                  return c;
                }),
              }));
            }}
          />
        )}
        {aba === 'relatorios' && <PortalRelatorios token={token} />}
        {aba === 'acessos' && <PortalAcessos acessos={dados.acessos} />}
      </div>
    </div>
  );
}
